import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPages.css';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { fetchCustomers(); }, []);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get('/api/admin/customers');
      setCustomers(res.data);
    } catch (err) {
      console.error('Error fetching customers:', err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = customers.filter(c =>
    !searchTerm ||
    (c.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (c.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (c.phone || '').includes(searchTerm)
  );

  if (loading) return <div className="admin-loading">Loading...</div>;

  return (
    <div className="admin-page admin-page-wide">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">Customers</h2>
          <p className="admin-page-desc">View customer accounts and order history. ({customers.length} total)</p>
        </div>
      </div>

      <div className="admin-filters">
        <input
          type="text" placeholder="Search by name, email or phone..."
          value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
          className="admin-filter-input"
        />
      </div>

      <div className="admin-page-card admin-table-card">
        <div className="admin-notifications-table">
          <table>
            <thead>
              <tr><th>Name</th><th>Email</th><th>Phone</th><th>Orders</th><th>Total Spent</th><th>Joined</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan="6" className="admin-no-data">No customers yet.</td></tr>
              ) : filtered.map(c => (
                <tr key={c._id}>
                  <td><strong>{c.name || '--'}</strong></td>
                  <td>{c.email}</td>
                  <td>{c.phone || '--'}</td>
                  <td>{c.orderCount ?? 0}</td>
                  <td>{c.totalSpent ? `₹${c.totalSpent}` : '₹0'}</td>
                  <td>{new Date(c.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Customers;
